
            const data = {"name":"clock-icon","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.5 11.75a8.25 8.25 0 1116.5 0 8.25 8.25 0 01-16.5 0zM11.75 2C6.365 2 2 6.365 2 11.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.135 2 11.75 2zM11 6.75v5.31l.22.22 3.25 3.25 1.06-1.06-3.03-3.03V6.75H11z\" _fill=\"#1A1A1A\"/>"}}
        
                module.exports = data
                